<template>
  <div class="content-wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <app-breadcrumb :page-title="$t('transportations')"/>
      <div class="mb-4">
                <button type="button" v-if="$can('create_expenses')"
                        class="btn btn-primary btn-with-shadow"
                        @click="exportAllTransportations">
                  <app-icon name="download" class="size-20 mr-2"/>
                  {{ $t('export_all') }}
                </button>
        <button type="button" v-if="$can('create_invoices')"
                class="btn btn-success btn-with-shadow"
                @click="openModal">
          <app-icon name="plus" class="size-20 mr-2"/>
          {{ $t('add_transportation') }}
        </button>
      </div>
    </div>

    <app-table
        v-if="$can('view_invoices')"
        :id="tableId"
        :options="options"
        @action="getListAction"/>


    <app-transportations-create-edit-modal
        v-if="isModalActive"
        :table-id="tableId"
        :selected-url="selectUrl"
        :drivers="drivers"
        :beneficiaries="beneficiaries"
        :trucks="trucks"
        :trailers="trailers"
        :locations="locations"
        :client-number="clientNumber"
        @openPurposeAddEditModal="openPurposeAddEditModal"
        @closeModal="closeModal"
    />

    <app-delete-modal
        v-if="confirmationModalActive"
        modal-id="delete-confirm-modal"
        :message="$t('are_you_sure_to_delete_this_shipment')"
        @confirmed="confirmDelete"
        @cancelled="cancelledDelete"
    />
  </div>
</template>

<script>
import TransportationTableMixin from "../../../Mixins/TransportationTableMixin";
import AppFunction from "../../../../core/helpers/app/AppFunction";
import {axiosGet, urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
  name: "transportations",
  mixins: [TransportationTableMixin],
  props: {
    drivers: {},
    beneficiaries: {},
    trucks: {},
    trailers: {},
    locations: {},
    googleKey: '',
    clientNumber: '',
  },
  methods: {
    exportAllTransportations(){
      window.location.replace(urlGenerator('transportations/export'))
    },
    openPurposeAddEditModal() {
      this.isPurposeModalActive = true;
      setTimeout(() => {
        $('#expense-create-edit-modal').css({
          opacity: '0.5',
        });
      });
    },
    closePurposeAddEditModal() {
      this.isPurposeModalActive = false;
      setTimeout(() => {
        $('#expense-create-edit-modal').css({
          opacity: '1',
        });
      });
      $("#purpose-add-edit-modal").modal("hide");
    },
    afterPurposeAdded() {
      this.$hub.$emit('new-purpose-added')
    },
    closeModal() {
      this.selectUrl = "";
      this.isModalActive = false;
    },
    cancelledDelete() {
      this.selectUrl = '';
      this.confirmationModalActive = false;
      $("#delete-confirm-modal").modal("hide");
    },
  },
  mounted() {
    this.$el.addEventListener('reload_table', this.$hub.$emit('reload-' + this.id));
    window.addEventListener('reload_table', () => {
      this.$hub.$emit('reload-transportations-table');
    });
    // console.log(this.locations);
    // let googlePlaces = document.createElement('script');
    // googlePlaces.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + this.googleKey + '&libraries=places');
    // document.head.appendChild(googlePlaces);
  },
  destroyed() {
    this.$el.removeEventListener('reload_table', this.$hub.$emit('reload-' + this.id));
  }
}
</script>

<style scoped>

</style>
